import {t} from '@/lib/i18n'

type ColorSwatchProps = {
  hex: string
  label?: string
}

export function ColorSwatch({hex, label}: ColorSwatchProps) {
  return (
    <span
      className="block size-4 rounded-full border border-neutral-300"
      style={{backgroundColor: hex}}
      role="img"
      aria-label={label || hex}
      title={label}
    />
  )
}

type ColorSwatchesProps = {
  colors: Array<{hex: string; label?: string}>
  max?: number
  /** Accessible group label for screen readers */
  groupLabel?: string
  /** Active site locale for i18n fallback of groupLabel */
  locale?: string
}

export function ColorSwatches({colors, max = 5, groupLabel, locale}: ColorSwatchesProps) {
  if (!colors.length) return null

  const visible = colors.slice(0, max)
  const overflow = colors.length - max

  return (
    <div
      className="flex items-center gap-2"
      role="group"
      aria-label={groupLabel || t(locale, 'product.colorOptions', 'Color options')}
    >
      {visible.map((color, index) => (
        <ColorSwatch key={`${color.hex}-${index}`} hex={color.hex} label={color.label} />
      ))}
      {overflow > 0 && <span className="text-xs text-muted-foreground">+{overflow}</span>}
    </div>
  )
}
